import { History } from "history";
import { combineReducers } from "redux";
import { createAction, getType } from "typesafe-actions";
import authenticationReducer, {
  AuthenticationState,
} from "../auth/reducer/authenticationReducer";
import commonReducer, { CommonState } from "../common/reducer/commonReducer";
import intlReducer, { IntlState } from "../intl/redux/intlReducer";

export const clearStoreAfterLogout = createAction("clearStoreAfterLogout")();

export interface AppState {
  intl: IntlState;
  common: CommonState;
  auth: AuthenticationState;
}

export default function createRootReducer(history: History) {
  const rawRootReducer = combineReducers({
    intl: intlReducer,
    common: commonReducer,
    auth: authenticationReducer,
  });

  return (state: any, action: any): AppState => {
    if (state && action.type === getType(clearStoreAfterLogout)) {
      return rawRootReducer(undefined, action);
    }
    return rawRootReducer(state, action);
  };
}
